// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit"

export const modalWelcome = createSlice({
  name: "modalWelcome",
  initialState: {
    toggle: false,
    title: "",
    description: ""
  },
  reducers: {
    showWelcomeModal: (state, action) => {
      state.toggle = true
      state.title = action.payload?.title || ""
      state.description = action.payload?.description || ""
    },
    hideWelcomeModal: (state) => {
      state.toggle = false
      state.title = ""
      state.description = ""
    }
  }
})

export const { showWelcomeModal, hideWelcomeModal } = modalWelcome.actions

export default modalWelcome.reducer
